<template>
    <ConsultDetails/>
</template>
<script>
import ConsultDetails from 'place/consultation/consultDetails.vue'
export default {
    components:{
        ConsultDetails
    }
}
</script>